import React from 'react';
import PropTypes from 'prop-types';
import ButtonEdit from '../ButtonEdit';
import View from './View';
import Edit from './Edit';

const BasicCoverage = ({
  edit,
  confirm,
  enabled,
  confirmed,
  value,
  options,
  basicCoverageRef,
  aboutEventRef,
  scrollToPosition,
  ACSellingLiquor,
}) => (
  <div
    className={`component ${enabled ? 'enabled' : 'disabled'}`}
    ref={basicCoverageRef}
  >
    <div className="form-row justify-content-between">
      <div className="col-auto my-auto">
        <h3>Basic Coverage</h3>
      </div>
      <ButtonEdit edit={edit} show={confirmed} />
    </div>
    <div className="card">
      <div className="card-body">
        <label className="mb-0 font-weight-bold" htmlFor="fieldCoverage">
          General Liability Coverage
        </label>
        <Edit
          show={!confirmed}
          confirm={confirm}
          fieldOptions={options}
          enabled={enabled}
          aboutEventRef={aboutEventRef}
          scrollToPosition={scrollToPosition}
          ACSellingLiquor={ACSellingLiquor}
        />
        <View
          show={confirmed}
          value={value}
          basicCoverageRef={basicCoverageRef}
          ACSellingLiquor={ACSellingLiquor}
        />
      </div>
    </div>
  </div>
);
BasicCoverage.propTypes = {
  edit: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  enabled: PropTypes.bool.isRequired,
  confirmed: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string.isRequired,
  scrollToPosition: PropTypes.func.isRequired,
  basicCoverageRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  aboutEventRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  ACSellingLiquor: PropTypes.bool.isRequired,
};

export default BasicCoverage;
